import React from "react";

const Initials = ({ firstName, lastName, styles = "" }) => (
  <div
    className={`${styles ||
      "tw-w-20 tw-h-20 tw-m-1 tw-mx-2 tw-mr-3 tw-cursor-pointer"}`}
  >
    <div className="tw-bg-gray-200 tw-flex tw-justify-center tw-items-center tw-text-lg tw-h-full tw-w-full hover:tw-border-yellow-300 tw-rounded-full tw-border-2 tw-border-gray-400 tw-shadow-sm">
      {firstName[0]}
      {lastName[0]}
    </div>
  </div>
);

export default Initials;
